import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getIndianapolisStructuredData() {
  const url = "https://restorehair.com/locations/indiana/indianapolis/";
  const description =
    "Find out about your hair transplant options in Indianapolis with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("indianapolis", url, description),
    locationPageCrumbs(url, "Indianapolis"),
  ];
}
